/*
 * @Author: yaodongyi
 * @Date: 2025-06-26 21:48:04
 * @LastEditors: yaodongyi
 * @LastEditTime: 2025-07-09 18:04:27
 * @Description: 支付相关接口
 */
import request from "../utils/request";
import Variable from "../utils/variable";

const GlobalVariable = new Variable().GlobalVariable;
const payConf = {
  API_BASE_URL: GlobalVariable.API_BASE_URL,
};
const Config = payConf;

/**
 * 获取独立支付信息
 * @param liveroom_id 直播间id
 * @param props 参数
 * @param onSuccess 成功回调 { isIndependent: boolean; domain: string }
 * @param onFailed 失败回调 错误信息
 */
export const api_getDomainInfo = (
  liveroom_id: any,
  props: { token: string; choice_type?: "pgc" | "ugc" },
  onSuccess: (data: { isIndependent: boolean; domain: string }) => void,
  onFailed: (err: any) => void
) => {
  return request(
    {
      method: "POST",
      dataType: "json",
      baseUrl: Config.API_BASE_URL,
      url: "/api/pay/get_domain_info",
      query: { token: props.token },
      data: { liveroom_id, choice_type: props.choice_type },
    },
    (data) => {
      // 后端代码其实不会有非0的情况，这里避免后续后端扩展，先做好兼容
      if (data && data.code === 0 && data.data) {
        onSuccess({
          isIndependent: !!data.data.is_cashier_counter,
          domain: data.data.domain,
        });
      } else {
        onFailed(data);
      }
    },
    onFailed
  );
};

/**
 * 预下单
 * @param params 支付参数（wx,pc,app等）
 * @param token 用户token
 * @returns { data: { pay_hash_key: string }; code: number }
 */
export const api_preOrder = (
  params: { [key: string]: string | number },
  token: string
) => {
  return new Promise<{ data: { pay_hash_key: string }; code: number }>(
    (resolve, reject) => {
      request(
        {
          method: "POST",
          dataType: "json",
          baseUrl: Config.API_BASE_URL,
          url: "/api/pay/pre_order",
          query: { token },
          data: { ...params },
        },
        resolve,
        reject
      );
    }
  );
};
